/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from 'core/ui/Box';
import useSelectors from 'modules/map/useSelectors';
import { channelReportsModule } from 'modules/channelReports';
import Grid from 'core/ui/Grid';
import ChoosenChannelTags from 'core/ui/ChoosenChannelTags';
import { useTranslation } from 'react-i18next';
import SkeletonAtRiskMembersReport from './Skeleton';
import ResultMembers from './ResultMembers';

const AtRiskMembers = ({ channel, loading, getReport }) => {
  const { t } = useTranslation();
  const data = useSelectors(channelReportsModule, 'data');
  const [filters, setFilters] = useState({ membersTags: [], membershipsTags: [] });

  useEffect(() => {
    getReport(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  return (
    <Box mt={2}>
      <Box flexGrow={1} mb={3}>
        <Grid container spacing={5}>
          <Grid item xs={12} md={4}>
            <ChoosenChannelTags
              label={t('channel.label.memberTags')}
              placeholder={t('channel.tags')}
              val={filters?.membersTags ? [...filters?.membersTags] : []}
              setValue={(v) =>
                setFilters((prev) => ({ ...prev, membersTags: v?.map((x) => x?.name || x) }))
              }
              channelId={channel?.id}
              bordered
            />
          </Grid>
        </Grid>
      </Box>
      <Box>
        {!data.members || loading ? (
          <SkeletonAtRiskMembersReport />
        ) : (
          <Box>
            <ResultMembers channel={channel} members={data.members} />{' '}
          </Box>
        )}
      </Box>
    </Box>
  );
};

AtRiskMembers.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  loading: PropTypes.bool,
  getReport: PropTypes.func,
};

AtRiskMembers.defaultProps = {
  loading: false,
  getReport: () => {},
};

export default AtRiskMembers;
